export default {
  "productPhotos": { "unsavedTitle":"¿Guardar los cambios?","unsavedBody":"Guarda o descarta la opción de fotos de productos antes de salir de esta plantilla.","save":"Guardar","discard":"Descartar","cancel":"Cancelar","saveFailed":"No se pudieron guardar los cambios. Se ha conservado la opción pendiente. Inténtalo de nuevo.","label": "Mostrar fotos de los productos", "help": "Usa las fotos ya guardadas en los productos. Guarda el diseño para conservar esta opción." },
  "copy0": "El consumo de la receta se puede introducir en unidades compatibles con",
  "copy1": "No se encontraron coincidencias.",
  "copy2": "Nombre",
  "copy3": "Bar principal",
  "copy4": "Tipo de punto de venta",
  "copy5": "Seleccionar tipo de punto de venta",
  "copy6": "Menús disponibles en este punto de venta",
  "copy7": "Selecciona todos los menús que se pueden servir aquí y elige uno predeterminado.",
  "copy8": "Pedidos públicos habilitados",
  "copy9": "Modo de servicio",
  "copy10": "Seleccionar modo de servicio",
  "copy11": "Servicio rápido",
  "copy12": "Servicio de mesa",
  "copy13": "Selección de mesa",
  "copy14": "Seleccionar requisito",
  "copy15": "Obligatoria",
  "copy16": "Opcional",
  "copy17": "Zonas de comedor",
  "copy18": "Crea primero las zonas de comedor para asignarlas aquí.",
  "copy19": "Ubicación de inventario",
  "copy20": "Ubicación opcional",
  "copy21": "Sin ubicación",
  "copy22": "Punto de venta activo",
  "copy23": "Habilita o deshabilita este punto de venta.",
  "copy24": "Cancelar",
  "copy25": "Guardar punto de venta",
  "copy26": "Cena del comedor",
  "copy27": "Asignación de puntos de venta",
  "copy28": "Asigna este menú desde la configuración de los puntos de venta.",
  "copy29": "Menú activo",
  "copy30": "Oculta o publica este menú.",
  "copy31": "Habilitar para servicio de habitaciones",
  "copy32": "Publica este menú en las pantallas de las habitaciones.",
  "copy33": "Recargo (%)",
  "copy34": "Gastos de entrega",
  "copy35": "El recargo se aplica a cada artículo de este menú. Los gastos de entrega se aplicarán una vez por pedido en una fase posterior.",
  "copy36": "Artículos del menú",
  "copy37": "Actualiza los artículos que aparecen en este menú.",
  "copy38": "Texto del botón",
  "copy39": "Nombre del artículo",
  "copy40": "Tamaño del envase",
  "copy41": "Coste",
  "copy42": "Precio de venta",
  "copy43": "Acciones",
  "copy44": "Todavía no hay artículos en el menú.",
  "copy45": "Individual",
  "copy46": "0.00",
  "copy47": "Duplicar menú",
  "copy48": "Guardar menú",
  "copy49": "¿Eliminar artículo del menú?",
  "copy50": "Eliminar",
  "copy51": "de este menú.",
  "copy52": "Selecciona un punto de venta para generar un enlace de acceso.",
  "copy53": "Enlace de acceso",
  "copy54": "URL segura del punto de venta y código de un solo uso renovable.",
  "copy55": "URL del punto de venta",
  "copy56": "Código de un solo uso",
  "copy57": "Caduca en",
  "copy58": "QR pendiente",
  "copy59": "Escanea para abrir el terminal",
  "copy60": "Regenerar secreto del terminal",
  "copy61": "Acceso del personal al TPV",
  "copy62": "Asigna personal del club para acceder con un PIN de caja. Los hashes de los PIN permanecen en el servidor y los PIN antiguos nunca se muestran.",
  "copy63": "Buscar personal asignado…",
  "copy64": "Añadir personal",
  "copy65": "Asignado",
  "copy66": "PIN establecido",
  "copy67": "Último acceso:",
  "copy68": "Nivel de permisos",
  "copy69": "Estándar",
  "copy70": "Ampliado",
  "copy71": "Generar/restablecer PIN",
  "copy72": "Eliminar de ePOS",
  "copy73": "Acceso a puntos de venta",
  "copy74": "Todos los puntos de venta",
  "copy75": "Esta persona puede acceder a todos los puntos de venta del TPV.",
  "copy76": "No hay personal asignado a ePOS.",
  "copy77": "Añadir personal de ePOS",
  "copy78": "Selecciona una o más personas activas del club. La asignación no cambia su cuenta de personal.",
  "copy79": "Buscar personal disponible…",
  "copy80": "Asignar seleccionados",
  "copy81": "Nuevo PIN del TPV",
  "copy82": "Este PIN solo se muestra una vez. No se puede recuperar después.",
  "copy83": "Copiar PIN",
  "copy84": "Listo",
  "copy85": "no tiene habilitado el módulo de gestión de ePOS.",
  "copy86": "Asistente de configuración",
  "copy87": "Crear punto de venta",
  "copy88": "Crear menú",
  "copy89": "Puntos de venta activos",
  "copy90": "Puntos de venta que aceptan pedidos actualmente.",
  "copy91": "Menús activos",
  "copy92": "Menús asignados a puntos de venta y habilitados.",
  "copy93": "Botones configurados",
  "copy94": "Botones configurados en el menú seleccionado.",
  "copy95": "Resumen de puntos de venta",
  "copy96": "Accede rápidamente a los enlaces de acceso y estados.",
  "copy97": "Todavía no hay puntos de venta",
  "copy98": "Crea tu primer punto de venta para empezar a configurar menús.",
  "copy99": "Enlace de acceso",
  "copy100": "Puntos de venta",
  "copy101": "Actualizar",
  "copy102": "Gestiona las ubicaciones de servicio y sus valores predeterminados.",
  "copy103": "Configura un bar, comedor o tienda de golf.",
  "copy104": "Actualizado",
  "copy105": "Editar punto de venta",
  "copy106": "Detalles del punto de venta",
  "copy107": "Menú predeterminado y asignaciones de inventario.",
  "copy108": "Menú predeterminado",
  "copy109": "Punto de venta",
  "copy110": "Ubicación de inventario",
  "copy111": "Existencias",
  "copy112": "Menús",
  "copy113": "Asigna menús a puntos de venta y mantenlos actualizados.",
  "copy114": "Todavía no hay menús",
  "copy115": "Crea tu primer menú y empieza a añadir botones.",
  "copy116": "Selector de menú",
  "copy117": "Seleccionar un menú",
  "copy118": "puntos de venta)",
  "copy119": "Editar menú",
  "copy120": "Duplicar",
  "copy121": "Editor de menú",
  "copy122": "Diseña la cuadrícula de botones del menú seleccionado.",
  "copy123": "artículo",
  "copy124": "configurados.",
  "copy125": "Elige un menú para empezar a configurar botones.",
  "copy126": "Todos los productos activos de ePOS",
  "copy127": "Busca, filtra y selecciona varios productos para añadirlos juntos.",
  "copy128": "Añadir seleccionados",
  "copy129": "Buscar productos...",
  "copy130": "Categoría",
  "copy131": "Buscando artículos...",
  "copy132": "Añadido",
  "copy133": "Botones",
  "copy134": "No se pudieron cargar los botones del menú.",
  "copy135": "Este menú no tiene botones",
  "copy136": "Busca productos activos de ePOS arriba y pulsa Añadir para crear la cuadrícula del TPV.",
  "copy137": "Añadir artículos",
  "copy138": "No se encuentra el registro del artículo en el inventario.",
  "copy139": "El artículo está inactivo o no se puede vender.",
  "copy140": "Productos de ePOS",
  "copy141": "Los productos son lo que compran los socios y huéspedes en caja; las recetas gestionan el consumo de existencias.",
  "copy142": "Crear producto",
  "copy143": "Los productos no están disponibles temporalmente.",
  "copy144": "Nombre del producto*",
  "copy145": "Nombre del producto",
  "copy146": "p. ej., pinta de Carling",
  "copy147": "Cerveza de barril",
  "copy148": "Precio de venta mostrado al socio/huésped",
  "copy149": "Precio de venta",
  "copy150": "6.50",
  "copy151": "¿El precio de venta incluye IVA?",
  "copy152": "Sí",
  "copy153": "No",
  "copy154": "Código fiscal",
  "copy155": "Artículo de inventario vinculado (solo como ayuda para recetas)",
  "copy156": "Seleccionar artículo de inventario",
  "copy157": "Sin artículo de receta vinculado",
  "copy158": "Imagen del producto",
  "copy159": "Subir imagen del producto",
  "copy160": "Enviar a KDS / requiere preparación",
  "copy161": "Desactivado por defecto por seguridad. Los productos que requieren KDS utilizan las reglas de enrutamiento.",
  "copy162": "Categoría de preparación",
  "copy163": "Editar en Inventario",
  "copy164": "Editar",
  "copy165": "Desactivar",
  "copy166": "Crear receta",
  "copy167": "Todavía no hay productos de ePOS",
  "copy168": "Crea aquí los botones de caja, como pinta de Carling, botella de Coca-Cola o hamburguesa con queso.",
  "copy169": "Recetas",
  "copy170": "Las recetas definen qué artículos de inventario se consumen al vender un producto del TPV.",
  "copy171": "Las recetas no están disponibles temporalmente.",
  "copy172": "Elige un producto y define las existencias consumidas por venta.",
  "copy173": "Cancelar edición",
  "copy174": "Producto*",
  "copy175": "Seleccionar producto de ePOS",
  "copy176": "Buscar productos por nombre, SKU, código, categoría, subcategoría o unidad...",
  "copy177": "Ingredientes / inventario consumido",
  "copy178": "Añadir ingrediente",
  "copy179": "Artículo con control de existencias",
  "copy180": "Buscar artículos de inventario por nombre, SKU, código, categoría, subcategoría o unidad...",
  "copy181": "Cantidad consumida",
  "copy182": "568",
  "copy183": "Editar líneas",
  "copy184": "Todavía no hay recetas",
  "copy185": "Usa el asistente de configuración o crea un producto y define qué existencias consume.",
  "copy186": "Transacciones de ePOS",
  "copy187": "Pedidos, cuentas y comandas operativas, y registros de ventas/pagos completados con trazabilidad de inventario.",
  "copy188": "Fecha de transacción desde",
  "copy189": "Fecha de transacción hasta",
  "copy190": "Punto de venta de la transacción",
  "copy191": "Estado de la transacción",
  "copy192": "Estado",
  "copy193": "Estado predeterminado",
  "copy194": "Pedidos activos",
  "copy195": "Abierto",
  "copy196": "Pago pendiente",
  "copy197": "Enviado a cocina",
  "copy198": "Sin pagar",
  "copy199": "Pagado / completado",
  "copy200": "Anulado",
  "copy201": "Reembolsado",
  "copy202": "Cancelado",
  "copy203": "Buscar transacciones",
  "copy204": "Buscar venta, mesa o producto",
  "copy205": "Restablecer filtros",
  "copy206": "Pedidos",
  "copy207": "Ventas",
  "copy208": "Cargando transacciones…",
  "copy209": "Ver detalles",
  "copy210": "No hay pedidos operativos para los filtros seleccionados.",
  "copy211": "No hay ventas completadas para los filtros seleccionados.",
  "copy212": "Cargando detalles…",
  "copy213": "Número",
  "copy214": "Mesa",
  "copy215": "Personal / cajero",
  "copy216": "Total",
  "copy217": "Subtotal",
  "copy218": "Impuestos",
  "copy219": "Artículos",
  "copy220": "Cant.",
  "copy221": "No hay artículos registrados.",
  "copy222": "Pagos",
  "copy223": "No hay pagos registrados.",
  "copy224": "Resumen de cuenta por cobrar",
  "copy225": "Original",
  "copy226": "• Pendiente",
  "copy227": "Resumen de asignación de pagos",
  "copy228": "Impacto en la cuenta del socio",
  "copy229": "Desglose fiscal",
  "copy230": "Resumen del libro mayor",
  "copy231": "Débitos",
  "copy232": "Créditos",
  "copy233": "Debe",
  "copy234": "• Haber",
  "copy235": "Resumen de consumo de inventario",
  "copy236": "Cantidad",
  "copy237": "• Cantidad de receta",
  "copy238": "Editar producto de ePOS",
  "copy239": "Actualiza los detalles del producto de caja que ven los socios y huéspedes.",
  "copy240": "Editar nombre del producto",
  "copy241": "Editar precio de venta",
  "copy242": "Artículo de inventario vinculado",
  "copy243": "Sin vínculo directo a inventario",
  "copy244": "Vista previa del producto",
  "copy245": "Sin imagen",
  "copy246": "Editar imagen del producto",
  "copy247": "Los productos que requieren KDS se enviarán a la primera regla activa que coincida.",
  "copy248": "Activo / a la venta",
  "copy249": "Guardar producto",
  "copy250": "¿Desactivar producto?",
  "copy251": "Retira el producto de la selección activa de ePOS y conserva su historial.",
  "copy252": "Asistente de configuración de Inventario / ePOS",
  "copy253": "Artículo de inventario = lo que compra/almacena el club. Producto de ePOS = lo que compra el socio/huésped. Receta = existencias consumidas por venta; por ejemplo, almacenar un barril de 30 L, vender una pinta y consumir 568 ml del barril.",
  "copy254": "¿Qué estás configurando?",
  "copy255": "El asistente utiliza únicamente los campos siguientes. Las sugerencias de IA estarán disponibles más adelante mediante una función actualmente deshabilitada.",
  "copy256": "Nombre del artículo de inventario*",
  "copy257": "p. ej., barril de cerveza de 30 L",
  "copy258": "SKU / código de barras / código de artículo",
  "copy259": "Cerveza",
  "copy260": "Unidad de compra",
  "copy261": "Cantidad / tamaño de compra",
  "copy262": "30",
  "copy263": "Unidad del tamaño de compra",
  "copy264": "Precio de coste del proveedor",
  "copy265": "100.00",
  "copy266": "Código fiscal de compra",
  "copy267": "ID de código fiscal opcional",
  "copy268": "Nombre del producto de ePOS*",
  "copy269": "p. ej., producto de pinta",
  "copy270": "¿Consume una unidad de inventario por venta?",
  "copy271": "Sí, consumir 1 unidad",
  "copy272": "No, definiré las líneas de receta",
  "copy273": "Cantidad consumida por ración",
  "copy274": "Unidad de ración",
  "copy275": "Producto de ePOS existente*",
  "copy276": "Seleccionar producto",
  "copy277": "Ingredientes de receta",
  "copy278": "1",
  "copy279": "Crear configuración",
  "copy280": "Venta actual",
  "copy281": "Asignar mesa",
  "copy282": "Borrar",
  "copy283": "Eliminar artículo seleccionado",
  "copy284": "Artículos",
  "copy285": "IVA incluido",
  "copy286": "Cobrar",
  "copy287": "Terminal TPV",
  "copy288": "¿Borrar venta actual?",
  "copy289": "Cancelar borrado de venta",
  "copy290": "Se eliminará la asignación de mesa actual y se borrará la venta de este terminal.",
  "copy291": "Enviar a cocina",
  "copy292": "Cerrar",
  "copy293": "Notas de preparación",
  "copy294": "Añadir notas de preparación (opcional)",
  "copy295": "Preparar ahora",
  "copy296": "Introducir código de barras",
  "copy297": "Compatible con escáneres USB/Bluetooth e introducción manual.",
  "copy298": "Cerrar entrada de código de barras",
  "copy299": "Escanea o escribe el código de barras",
  "copy300": "Volver a enfocar el escáner",
  "copy301": "Último escaneado:",
  "copy302": "· Añadido",
  "copy303": "Bloquear",
  "copy304": "Acceso del personal",
  "copy305": "Acceso del personal — Introduce tu código de 4 dígitos",
  "copy306": "PIN del personal",
  "copy307": "Borrar",
  "copy308": "Personal:",
  "copy309": "Abrir opciones del terminal",
  "copy310": "Opciones del terminal",
  "copy311": "Cerrar opciones del terminal",
  "copy312": "Elige entre cerrar la sesión de la persona actual o bloquear este terminal.",
  "copy313": "Cerrar sesión",
  "copy314": "Bloquear pantalla",
  "copy315": "Menú",
  "copy316": "Mesas",
  "copy317": "Abrir entrada manual de código de barras",
  "copy318": "Escanear / Código de barras",
  "copy319": "Selecciona una mesa para empezar.",
  "copy320": "Modo de vista de mesas",
  "copy321": "Cuadrícula",
  "copy322": "Plano",
  "copy323": "No hay zonas de comedor asignadas a este punto de venta.",
  "copy324": "Todavía no hay mesas en esta zona.",
  "copy325": "Ocupada",
  "copy326": "Pago",
  "copy327": "Total a pagar",
  "copy328": "Tarjeta",
  "copy329": "Cobrar (tarjeta presencial)",
  "copy330": "Efectivo",
  "copy331": "Liquidación inmediata",
  "copy332": "Socio",
  "copy333": "Lector simulado (modo de prueba)",
  "copy334": "Preparando nueva venta…",
  "copy335": "v",
  "copy336": "· Actualizado",
  "copy337": "Asignado:",
  "copy338": "Publicar",
  "copy339": "Archivar",
  "copy340": "Editar plantilla",
  "copy341": "Gestiona los detalles de la plantilla, su estado y la seguridad de las asignaciones.",
  "copy342": "Nombre de plantilla",
  "copy343": "Descripción",
  "copy344": "Tamaño de terminal predeterminado",
  "copy345": "Puntos de venta asignados",
  "copy346": "Al eliminar una plantilla se desactivan estas asignaciones para que los puntos de venta utilicen otra plantilla disponible o el menú anterior.",
  "copy347": "Volver a borrador",
  "copy348": "Restaurar como borrador",
  "copy349": "Eliminar plantilla",
  "copy350": "Guardar",
  "copy351": "Eliminar plantilla de TPV",
  "copy352": "Confirma la eliminación de esta plantilla del diseñador de pantallas del TPV.",
  "copy353": "Plantilla:",
  "copy354": "Las asignaciones activas de esta plantilla se desactivarán antes de eliminarla.",
  "copy355": "Se desvincularán las plantillas secundarias y las referencias a copias para conservar las plantillas relacionadas.",
  "copy356": "Carpeta ·",
  "copy357": "artículos",
  "copy358": "An+",
  "copy359": "An-",
  "copy360": "Al+",
  "copy361": "Al-",
  "copy362": "Privana Assist",
  "copy363": "Instrucción de diseño del TPV para Privana Assist",
  "copy364": "Describe la pantalla del TPV que quieres crear o mejorar…",
  "copy365": "Diseñando…",
  "copy366": "Enviar",
  "copy367": "Privana está diseñando tu pantalla…",
  "copy368": "Revisando y ajustando tus productos, páginas y diseño táctil.",
  "copy369": "Propuesta lista para revisar",
  "copy370": "Revisar propuesta",
  "copy371": "Regenerar",
  "copy372": "Cambiar productos",
  "copy373": "Cancelar propuesta pendiente",
  "copy374": "Cancelar propuesta",
  "copy375": "Elige productos para esta pantalla del TPV",
  "copy376": "Selecciona hasta 100 productos para que Privana Assist los organice.",
  "copy377": "Buscar productos",
  "copy378": "Buscar por nombre, SKU o código de barras",
  "copy379": "producto",
  "copy380": "mostrados",
  "copy381": "Seleccionar visibles",
  "copy382": "Borrar selección",
  "copy383": "No hay productos de ePOS disponibles.",
  "copy384": "Ningún producto coincide con la búsqueda.",
  "copy385": "de 100 seleccionados",
  "copy386": "Esta confirmación utiliza tu plantilla y los productos seleccionados. La generación aún no ha comenzado.",
  "copy387": "Optimizaré para:",
  "copy388": "Objetivo de diseño",
  "copy389": "(opcional)",
  "copy390": "Atrás",
  "copy391": "Cambiar tipo de comercio",
  "copy392": "Por qué Privana recomendó este diseño",
  "copy393": "Confianza del diseño",
  "copy394": "Recomendaciones",
  "copy395": "Modo:",
  "copy396": "Dispositivo:",
  "copy397": "Eliminados",
  "copy398": "páginas,",
  "copy399": "nodos y",
  "copy400": "botones.",
  "copy401": "Por qué Privana lo diseñó así",
  "copy402": "Herramientas del diseñador de pantallas del TPV",
  "copy403": "Expandir barra lateral del diseñador",
  "copy404": "Expandir barra lateral",
  "copy405": "Diseñador de pantallas del TPV",
  "copy406": "Crea pantallas táctiles con tus productos y menús actuales.",
  "copy407": "Contraer barra lateral del diseñador",
  "copy408": "Contraer barra lateral",
  "copy409": "Herramientas de diseño",
  "copy410": "Crear plantilla",
  "copy411": "Generar diseño inicial desde menús",
  "copy412": "Las asignaciones específicas prevalecen sobre la asignación general.",
  "copy413": "Asignar a todos los puntos de venta",
  "copy414": "Asignar",
  "copy415": "Páginas",
  "copy416": "Subir",
  "copy417": "Bajar",
  "copy418": "Vinculado desde",
  "copy419": "botón de carpeta",
  "copy420": "; al eliminarla se utilizará la distribución automática de nodos secundarios.",
  "copy421": "Productos",
  "copy422": "Carpetas",
  "copy423": "Botón de carpeta",
  "copy424": "Próximamente",
  "copy425": "Contenido dinámico",
  "copy426": "Propiedades",
  "copy427": "Tema, diseño y ajustes del botón/nodo seleccionado.",
  "copy428": "Fondo del tema",
  "copy429": "Botón seleccionado",
  "copy430": "Color del botón",
  "copy431": "x",
  "copy432": ", y",
  "copy433": ", an",
  "copy434": ", al",
  "copy435": "Nada seleccionado",
  "copy436": "Selecciona un botón o nodo de navegación del lienzo para editar sus propiedades.",
  "copy437": "Nodo seleccionado",
  "copy438": "Página diseñada",
  "copy439": "Sin página diseñada",
  "copy440": "Clave de acción",
  "copy441": "Clave de fuente dinámica",
  "copy442": "Carpeta secundaria",
  "copy443": "Producto secundario",
  "copy444": "Eliminar nodo",
  "copy445": "Árbol de navegación",
  "copy446": "Espacio de trabajo del lienzo del TPV",
  "copy447": "Acciones de edición",
  "copy448": "Página",
  "copy449": "Guardar diseño",
  "copy450": "cuadrícula visible ·",
  "copy451": "filas desplazables",
  "copy452": "Empieza a crear esta página",
  "copy453": "Arrastra un elemento de la biblioteca al lienzo.",
  "copy454": "Estado del lienzo",
  "copy455": "columnas",
  "copy456": "filas visibles",
  "copy457": "filas lógicas",
  "copy458": "Privana",
  "copy459": "Socio (opcional)",
  "copy460": "Vincula un socio para atribución y recibos.",
  "copy461": "Aplicado",
  "copy462": "Número de socio",
  "copy463": "Cargando plano…",
  "copy464": "Centrar mesa seleccionada",
  "copy465": "Centrar selección",
  "copy466": "Alejar plano",
  "copy467": "Ajustar plano",
  "copy468": "Ajustar",
  "copy469": "Acercar plano",
  "copy470": "Leyenda de estados de las mesas del plano",
  "copy471": "Disponible",
  "copy472": "Seleccionada",
  "copy473": "Sin vincular",
  "copy474": "Zona",
  "copy475": "Cerrar resumen de zona",
  "copy476": "Asientos",
  "copy477": "No hay mesas vinculadas en esta zona",
  "copy478": "Este plano todavía no tiene mesas visuales vinculadas. La vista de cuadrícula sigue disponible.",
  "extra0": "Bar",
  "extra1": "Comedor",
  "extra2": "Tienda de golf",
  "extra3": "Casa del hoyo 9",
  "extra4": "Este artículo",
  "extra5": " o ",
  "extra6": "Sí",
  "extra7": "No",
  "extra8": "Autoservicio QR",
  "extra9": "Pago",
  "extra10": "Solo inventario",
  "extra11": "Producto comprado y vendido sin transformación",
  "extra12": "Cerveza de barril / bebida medida",
  "extra13": "Receta / comida",
  "extra14": "Elige un modo de configuración.",
  "extra15": "El nombre del artículo de inventario es obligatorio.",
  "extra16": "Selecciona un producto de ePOS existente.",
  "extra17": "El nombre del producto es obligatorio.",
  "extra18": "El precio de venta debe ser cero o superior.",
  "extra19": "La cantidad consumida debe ser mayor que cero.",
  "extra20": "Añade al menos un ingrediente o cambia al consumo de una unidad por venta.",
  "extra21": "Añade al menos un ingrediente de receta.",
  "extra22": "Seleccionar opción",
  "extra26": "Editar punto de venta",
  "extra27": "Crear punto de venta",
  "extra28": "Menú sin título",
  "extra29": "Activo",
  "extra30": "Inactivo",
  "extra31": "Ubicación de inventario",
  "extra32": "No se pudieron cargar los artículos del menú",
  "extra33": "Recargo no válido",
  "extra34": "El recargo debe estar entre 0 y 100.",
  "extra35": "Gastos de entrega no válidos",
  "extra36": "Los gastos de entrega deben ser cero o superiores.",
  "extra37": "Artículo del menú actualizado",
  "extra38": "No se pudo actualizar el artículo del menú",
  "extra39": "Artículo del menú eliminado",
  "extra40": "No se pudo eliminar el artículo del menú",
  "extra41": "Editar menú",
  "extra42": "Crear menú",
  "extra43": "Guardar",
  "extra44": "este artículo",
  "extra45": "El enlace del punto de venta no está listo",
  "extra46": "Copiar URL del punto de venta",
  "extra47": "No se pudo cargar el personal del TPV",
  "extra48": "Inténtalo de nuevo.",
  "extra49": "No se pudo cargar el personal disponible",
  "extra50": "No se pudo asignar el personal",
  "extra51": "No se pudo guardar el acceso del personal",
  "extra52": "No se pudo restablecer el PIN",
  "extra53": "PIN copiado",
  "extra54": "Compártelo de forma segura con la persona correspondiente.",
  "extra55": "Habilitado",
  "extra56": "Deshabilitado",
  "extra57": "Personal del club",
  "extra59": "Nunca",
  "extra60": "Deshabilitar",
  "extra61": "Habilitar",
  "extra62": "Seleccionar producto",
  "extra63": "Receta preparada",
  "extra64": "Sin receta",
  "extra65": "Seleccionar artículo de inventario",
  "extra66": "Inténtalo de nuevo en breve.",
  "extra67": "No se pudieron cargar los puntos de venta",
  "extra68": "No se pudieron cargar los menús",
  "extra69": "No se pudieron cargar los artículos con control de existencias",
  "extra70": "Ubicaciones de inventario no disponibles",
  "extra71": "Zonas de comedor no disponibles",
  "extra72": "La búsqueda falló",
  "extra76": "Punto de venta actualizado",
  "extra77": "Punto de venta creado",
  "extra78": "No se pudo guardar el punto de venta",
  "extra79": "Menú actualizado",
  "extra80": "Menú creado",
  "extra81": "No se pudo guardar el menú",
  "extra82": "Menú duplicado",
  "extra83": "La duplicación falló",
  "extra84": "El nombre del producto es obligatorio",
  "extra85": "El precio de venta debe ser cero o superior",
  "extra86": "Producto creado",
  "extra87": "No se pudo crear el producto",
  "extra88": "Producto actualizado",
  "extra89": "No se pudo actualizar el producto",
  "extra90": "Producto desactivado",
  "extra91": "Este producto se utiliza en un menú. Retíralo de los menús antes de desactivarlo o inténtalo de nuevo tras actualizar el menú.",
  "extra92": "No se pudo desactivar el producto",
  "extra93": "Selecciona un producto.",
  "extra94": "Añade al menos una línea de receta.",
  "extra95": "Selecciona un artículo con control de existencias.",
  "extra96": "Introduce una cantidad mayor que cero.",
  "extra97": "Selecciona una unidad.",
  "extra98": "No se permiten líneas duplicadas del mismo ingrediente y unidad.",
  "extra100": "Error de validación de receta",
  "extra101": "Corrige los campos resaltados de la receta.",
  "extra102": "Receta actualizada",
  "extra103": "Receta guardada",
  "extra104": "No se pudo guardar la receta",
  "extra105": "No hay artículos nuevos seleccionados",
  "extra106": "Los artículos seleccionados ya están en este menú.",
  "extra107": "Artículos añadidos al menú",
  "extra108": "No se pudieron añadir los artículos seleccionados",
  "extra109": "No se pudo actualizar el texto",
  "extra110": "No se pudo eliminar el artículo del menú",
  "extra111": "No se pudo cambiar el orden",
  "extra112": "No se pudo obtener el código de un solo uso",
  "extra113": "Secreto del terminal regenerado",
  "extra114": "No se pudo regenerar el secreto",
  "extra115": "No se pudieron cargar las transacciones de ePOS.",
  "extra116": "No se pudieron cargar los detalles de la transacción.",
  "extra117": "Este club",
  "extra118": "Sin título",
  "extra119": "Abrir terminal del punto de venta",
  "extra121": "Sin configurar",
  "extra122": "Sin vincular",
  "extra123": "Menú sin asignar",
  "extra124": "Receta",
  "extra125": "Inventario vinculado",
  "extra126": "Todavía no hay receta",
  "extra127": "Producto de ePOS",
  "extra129": "Artículo sin nombre",
  "extra130": "Categoría de producto",
  "extra131": "Código fiscal",
  "extra132": "Comida",
  "extra133": "Bebidas",
  "extra134": "Postre",
  "extra135": "Cocina",
  "extra136": "Otro",
  "extra137": "Gestionado desde Inventario",
  "extra138": "Consume 1 unidad de inventario",
  "extra139": "A la venta",
  "extra140": "Editar líneas de receta",
  "extra141": "Crear receta",
  "extra142": "Actualizar receta",
  "extra143": "Guardar receta",
  "extra144": "Punto de venta",
  "extra145": "Apertura",
  "extra146": "Estado",
  "extra147": "Subtotal",
  "extra148": "Impuestos",
  "extra149": "Total",
  "extra150": "Personal",
  "extra151": "Acción",
  "extra152": "Invitado",
  "extra153": "Venta",
  "extra154": "Hora",
  "extra155": "Productos vendidos",
  "extra156": "Cant.",
  "extra157": "Bruto",
  "extra158": "Neto",
  "extra159": "Inventario",
  "extra160": "Contabilidad",
  "extra161": "Detalles de venta del TPV",
  "extra162": "Detalles de pedido del TPV",
  "extra163": "Resumen de la venta operativa con pagos, preparación y estado contable.",
  "extra164": "Resumen del pedido/cuenta operativa para personal y responsables.",
  "extra165": "Socio",
  "extra166": "Venta de",
  "extra167": "Socio / invitado",
  "extra168": "Artículo",
  "extra169": "Asignación anulada",
  "extra170": "Asignado",
  "extra171": "Cargo a socio",
  "extra172": "Cuenta contable",
  "extra173": "Artículo de inventario",
  "extra174": "Consumido",
  "extra175": "Editar categoría de producto",
  "extra176": "Editar código fiscal",
  "extra177": "Error de validación del asistente",
  "extra178": "Configuración creada",
  "extra179": "El asistente de configuración falló",
  "extra180": "Mesa no encontrada. Actualiza las mesas e inténtalo de nuevo.",
  "extra181": "No se encontró la venta de esta mesa ocupada. Actualiza las mesas e inténtalo de nuevo.",
  "extra182": "Esta mesa ya tiene una venta abierta. Actualiza las mesas y abre la venta existente.",
  "extra183": "La mesa ocupada no tenía un ID de venta y no se pudo recuperar. Actualiza las mesas e inténtalo de nuevo.",
  "extra184": "La sesión del TPV ha caducado. Desbloquea este terminal de nuevo.",
  "extra185": "Esta mesa pertenece a una zona de comedor compartida, pero este terminal no tiene autorización para acceder a la venta.",
  "extra186": "La sesión del TPV ha caducado o no está autorizada. Introduce el código de acceso e inténtalo de nuevo.",
  "extra187": "No se pudo abrir la mesa. Comprueba la conexión e inténtalo de nuevo.",
  "extra188": "El pago falló. Reinténtalo o elige otro método.",
  "extra189": "Este socio no tiene habilitados los cargos a cuenta.",
  "extra190": "Selecciona un socio antes de cargar a cuenta.",
  "extra191": "No se encontró al socio.",
  "extra192": "Se produjo un error. Inténtalo de nuevo.",
  "extra193": "Varios artículos coinciden con este código de barras",
  "extra194": "Código de barras no reconocido",
  "extra195": "Selecciona una mesa para empezar.",
  "extra196": "Pulsa artículos del menú para iniciar una venta.",
  "extra197": "Enviado a cocina",
  "extra198": "Enviar a cocina",
  "extra199": "Borrar venta",
  "extra200": "Confirmar envío",
  "extra201": "Terminal TPV",
  "extra202": "Acceder",
  "extra203": "El TPV está sin conexión. Comprueba la conexión e inténtalo de nuevo.",
  "extra204": "No se pudo cargar el plano. La vista de cuadrícula sigue disponible.",
  "extra206": "El PIN es ambiguo. Pide al responsable que restablezca uno de los PIN.",
  "extra207": "PIN no reconocido para este punto de venta.",
  "extra208": "No se pudo acceder. Comprueba la conexión e inténtalo de nuevo.",
  "extra209": "No se pudo iniciar una venta nueva. Comprueba la conexión e inténtalo de nuevo.",
  "extra210": "No se pudo añadir el artículo. Conexión perdida.",
  "extra211": "La venta aún no está lista",
  "extra212": "No se pudo eliminar el artículo. Conexión perdida.",
  "extra213": "No se pudo actualizar la cantidad. Conexión perdida.",
  "extra214": "No se pudo borrar la venta. Conexión perdida.",
  "extra215": "Registrando pago en efectivo…",
  "extra216": "Pago completado",
  "extra217": "Lector desconectado. Reconéctalo e inténtalo de nuevo.",
  "extra220": "No hay ningún lector registrado para esta ubicación en Stripe.",
  "extra221": "No hay lector simulado disponible. Habilita el lector simulado e inténtalo de nuevo.",
  "extra222": "No se ha configurado la ubicación de Terminal para este punto de venta.",
  "extra224": "Faltan métodos de pago en el SDK de Stripe Terminal. Recarga el terminal e inténtalo de nuevo.",
  "extra225": "El lector está ocupado. Desconecta la sesión activa e inténtalo de nuevo.",
  "extra228": "No se pudo conectar con el lector. Comprueba la red o reinicia el lector.",
  "extra229": "La cuenta de ingresos del TPV no está configurada para este artículo/club.",
  "extra230": "Tarjeta rechazada.",
  "extra231": "No se pudo conectar con Stripe Terminal. Comprueba la red e inténtalo de nuevo.",
  "extra232": "Selecciona una mesa antes de enviar a cocina.",
  "extra233": "Enviando a cocina…",
  "extra234": "Ya se envió a cocina.",
  "extra235": "Enviado a cocina.",
  "extra237": "Preparando lector…",
  "extra238": "Conectando lector…",
  "extra239": "Este punto de venta no tiene una ubicación de Stripe Terminal configurada.",
  "extra240": "Buscando lector simulado…",
  "extra241": "Buscando lector…",
  "extra242": "No hay lector simulado disponible.",
  "extra243": "Conectando con el lector…",
  "extra244": "Faltan métodos de pago en el SDK de Stripe Terminal.",
  "extra245": "Recogiendo método de pago…",
  "extra246": "Falta la intención de pago.",
  "extra247": "Procesando pago…",
  "extra248": "El procesamiento del pago falló.",
  "extra249": "Aprobado",
  "extra250": "Selecciona un socio para realizar el cargo.",
  "extra251": "Cargando a la cuenta del socio…",
  "extra252": "Añadido a la cuenta del socio",
  "extra253": "El cargo a la cuenta del socio falló. Reinténtalo o elige otro método.",
  "extra254": "No se pudo vincular al socio. Inténtalo de nuevo.",
  "extra255": "La venta aún no está lista. Inténtalo de nuevo.",
  "extra256": "Socio no encontrado. Comprueba el número e inténtalo de nuevo.",
  "extra257": "No se pudo desvincular al socio. Inténtalo de nuevo.",
  "extra258": "No se pudo quitar la mesa. Conexión perdida.",
  "extra259": "Listo",
  "extra260": "Sin mesa seleccionada",
  "extra261": "Pulsa para añadir · Mantén pulsado para modificadores",
  "extra262": "Disponible",
  "extra263": "Utiliza el código de barras/búsqueda de las herramientas del terminal.",
  "extra264": "Próximamente",
  "extra265": "Cargo a cuenta",
  "extra266": "Plantillas",
  "extra267": "Biblioteca",
  "extra268": "Propiedades",
  "extra269": "Plantilla de pantalla del TPV diseñada para uso táctil.",
  "extra270": "Todos los puntos de venta",
  "extra271": "Sin asignar",
  "extra272": "Esta plantilla no está asignada actualmente a ningún punto de venta.",
  "extra273": "Producto no disponible",
  "extra274": "Producto",
  "extra275": "Botón",
  "extra276": "Crea o selecciona una plantilla en borrador antes de usar Privana Assist.",
  "extra277": "Privana Assist solo puede actualizar borradores. Duplica esta plantilla para crear una versión editable.",
  "extra278": "Describe un diseño; la pantalla del TPV solo cambiará cuando lo revises y apliques.",
  "extra280": "Continuar",
  "extra281": "¿Para qué tipo de punto de venta estás diseñando?",
  "extra282": "Correcto",
  "extra284": "Privana diseñó este diseño",
  "extra285": "Actualizado",
  "extra286": "Nuevo",
  "extra287": "Aplicando de forma atómica…",
  "extra288": "Usar este diseño",
  "extra289": "Propuesta lista para revisar.",
  "extra290": "Privana Assist se canceló o agotó el tiempo de espera. Tu plantilla no ha cambiado.",
  "extra291": "Privana Assist no pudo preparar una propuesta segura. Tu plantilla no ha cambiado.",
  "extra292": "Generación de Privana Assist cancelada. Tu plantilla no ha cambiado.",
  "extra293": "No se pudo cancelar la propuesta.",
  "extra294": "No se pudo cancelar la propuesta antes de regenerarla.",
  "extra295": "No se pudo cancelar la propuesta antes de cambiar los productos.",
  "extra296": "Diseño aplicado. La plantilla sigue en borrador hasta que la publiques.",
  "extra297": "No se pudo aplicar la propuesta. No se ha realizado ningún cambio.",
  "extra307": "Asignado",
  "extra308": "Hereda la asignación general",
  "extra309": "Menú anterior como alternativa",
  "extra312": "No hay plantilla seleccionada",
  "extra313": "Crear una página",
  "extra315": "Sin plantilla",
  "extra316": "Introduce el código de un solo uso del responsable",
  "extra317": "Verificando código…",
  "extra318": "Se requiere acceso al terminal",
  "extra319": "Socio vinculado",
  "extra320": "Buscando…",
  "extra321": "Aplicar",
  "extra331": "General",
  "extra332": "Zona de comedor",
  "extra334": "Mesa",
  "extra340": "El plano aún no está configurado. Usa Gestión de comedor para crear uno.",
  "extra345": "Plano del comedor",
  "search": "Buscar…",
  "outletTypes": {
    "bar": "Bar",
    "dining": "Comedor",
    "pro_shop": "Tienda de golf",
    "halfway_house": "Casa del hoyo 9"
  },
  "setupModes": {
    "stock_only": "Solo inventario",
    "simple_product": "Producto comprado y vendido sin transformación",
    "draft_beer": "Cerveza de barril / bebida medida",
    "food_recipe": "Receta / comida"
  },
  "actions": {
    "open_tables": "Abrir mesas",
    "search_products": "Buscar productos",
    "member_lookup": "Buscar socio",
    "open_tabs": "Abrir cuentas",
    "discounts": "Descuentos",
    "refunds": "Reembolsos",
    "transfer_table": "Transferir mesa",
    "split_bill": "Dividir cuenta",
    "print_bill": "Imprimir cuenta"
  },
  "dynamic": {
    "todays_specials": "Especiales del día",
    "happy_hour": "Artículos de la hora feliz",
    "top_sellers": "Más vendidos",
    "recently_sold": "Vendidos recientemente",
    "low_stock": "Existencias bajas"
  },
  "devices": {
    "tablet10": "Tableta de 10 pulgadas",
    "terminal15": "Terminal de 15 pulgadas",
    "desktop": "Terminal de escritorio",
    "landscapeTablet": "Tableta horizontal"
  },
  "statuses": {
    "open": "Abierto",
    "pending": "Pendiente",
    "pending_payment": "Pago pendiente",
    "sent_to_kitchen": "Enviado a cocina",
    "unpaid": "Sin pagar",
    "paid": "Pagado",
    "completed": "Completado",
    "void": "Anulado",
    "voided": "Anulado",
    "refunded": "Reembolsado",
    "partially_refunded": "Reembolso parcial",
    "cancelled": "Cancelado",
    "failed": "Fallido",
    "processing": "En proceso",
    "succeeded": "Completado",
    "active": "Activo",
    "inactive": "Inactivo",
    "draft": "Borrador",
    "published": "Publicado",
    "archived": "Archivado",
    "standard": "Estándar",
    "enhanced": "Ampliado",
    "cash": "Efectivo",
    "card": "Tarjeta",
    "card_present": "Tarjeta presencial",
    "member_account": "Cuenta de socio",
    "member_charge": "Cargo a socio",
    "consumed": "Consumido",
    "settled": "Liquidado",
    "partially_paid": "Pago parcial",
    "closed": "Cerrado",
    "posted": "Contabilizado",
    "not_posted": "Sin contabilizar",
    "not_required": "No requerido",
    "sale": "Venta",
    "refund": "Reembolso",
    "pos_sale": "Venta del TPV",
    "pos_void": "Anulación del TPV",
    "pos_refund": "Reembolso del TPV",
    "warning": "Advertencia",
    "applied": "Aplicado",
    "deducted": "Deducido",
    "not_costed": "Sin valorar",
    "pending_cost": "Valoración pendiente",
    "reversed": "Revertido",
    "partially_settled": "Liquidación parcial",
    "authorized": "Autorizado",
    "sent": "Enviado",
    "partially_sent": "Enviado parcialmente",
    "build": "Crear",
    "improve": "Mejorar",
    "partial": "Parcial"
  },
  "units": {
    "each": "unidad",
    "ml": "ml",
    "L": "L",
    "g": "g",
    "kg": "kg",
    "bottle": "botella",
    "case": "caja",
    "keg": "barril",
    "barrel": "barrica",
    "packages": "envases",
    "package": "envase",
    "stock": "existencias"
  },
  "runtime": {
    "noItems": "No hay artículos configurados en el menú.",
    "searchHelp": "Busca entre todos los productos activos del club y añádelos a la venta actual.",
    "searchPlaceholder": "Buscar bebidas, comida, productos…",
    "searchUnavailable": "Búsqueda no disponible. Inténtalo de nuevo.",
    "searching": "Buscando…",
    "noMatches": "No hay productos coincidentes.",
    "startTyping": "Empieza a escribir para buscar productos.",
    "search": "Buscar",
    "home": "Inicio",
    "folder": "Carpeta",
    "emptyPage": "Esta página diseñada aún no tiene botones.",
    "emptyFolder": "Esta carpeta aún no tiene botones.",
    "unavailable": "Esta función aún no está disponible.",
    "unavailableLabel": "{label}, próximamente, no disponible",
    "codeDigit": "Dígito {digit} del código"
  },
  "recipe": {
    "packaged": "{name} se almacena en envases de {size} {packageUnit} ({unit}); el consumo de la receta puede introducirse en {units}.",
    "incompatible": "{name} utiliza {unit}; elige una unidad compatible."
  },
  "messages": {
    "orderCheck": "Pedido/cuenta",
    "tableMemberGuest": "Mesa/socio/invitado",
    "defaultMenu": " • Menú predeterminado: {name}",
    "default": "Predeterminado {name}",
    "assignedCount": "Asignado a {count} punto(s) de venta",
    "stocked": "Almacenado en envases de {size} {packageUnit} ({unit})",
    "removeStaff": "¿Eliminar a {name} de ePOS? Su cuenta de personal seguirá activa.",
    "linkedOne": "Este producto está vinculado uno a uno con {name}.",
    "schema": "El esquema de productos/recetas de ePOS aún se está migrando.",
    "genericError": "No se pudo completar esta acción. Inténtalo de nuevo.",
    "unassign": "Quitar mesa {name}",
    "clearing": "Borrando…",
    "sending": "Enviando…",
    "checking": "Comprobando…",
    "added": "Añadido: {name}",
    "kitchenNotified": "Enviado a cocina · {count} estación(es) notificada(s).",
    "kitchenFailed": "No se pudo notificar a cocina. Comprueba la conexión e inténtalo de nuevo.",
    "table": "Mesa {name}",
    "seats": "{count} asientos",
    "generating": "Generando…",
    "select": "Seleccionar {name}",
    "templateAssigned": "Esta plantilla tiene {count} asignación(es) de punto de venta: {names}.",
    "thinkRetail": "Creo que estás diseñando para: {name}.",
    "designedRetail": "Privana diseñó esta pantalla para: {name}",
    "pageNumber": "Página {number}",
    "deletePage": "¿Eliminar {name}? {count} botón(es) de carpeta ({folders}) abren esta página diseñada. Si continúas, esas carpetas utilizarán la distribución automática de sus nodos secundarios.",
    "openPanel": "Abrir panel {name}",
    "showSummary": "Mostrar resumen de {name}",
    "unlinked": "{name} sin vincular",
    "selectTable": "Seleccionar mesa {name}",
    "sku": "SKU {sku}",
    "taxRate": "Impuesto {rate}",
    "unitsOr": " o ",
    "recipeQty": " / Receta {quantity} {unit}"
  },
  "tax": {
    "noCode": "Sin código fiscal",
    "loading": "Cargando códigos fiscales…",
    "select": "Seleccionar código fiscal",
    "unavailable": "Códigos fiscales no disponibles"
  },
  "retail": {
    "golf_pro_shop": "Tienda de golf",
    "main_bar": "Bar principal",
    "restaurant": "Restaurante",
    "halfway_house": "Casa del hoyo 9",
    "coffee_shop": "Cafetería",
    "spa_retail": "Tienda del spa",
    "golf_academy": "Academia de golf",
    "tennis_shop": "Tienda de tenis",
    "padel_shop": "Tienda de pádel",
    "fitness_reception": "Recepción de gimnasio",
    "marina_shop": "Tienda del puerto deportivo",
    "generic_retail": "Comercio general",
    "other": "Otro"
  },
  "priorities": {
    "Fast checkout": "Cobro rápido",
    "Repeat purchases": "Compras habituales",
    "Premium equipment browsing": "Exploración de equipamiento de gama alta",
    "Upselling accessories": "Venta adicional de accesorios",
    "Fast service": "Servicio rápido",
    "Popular drinks": "Bebidas populares",
    "Simple staff navigation": "Navegación sencilla para el personal",
    "Fast table ordering": "Pedidos de mesa rápidos",
    "Clear courses": "Platos organizados por pase",
    "Add-on visibility": "Complementos visibles",
    "Grab-and-go purchases": "Compras para llevar",
    "Drink customisation": "Personalización de bebidas",
    "Food add-ons": "Complementos de comida",
    "Premium presentation": "Presentación de gama alta",
    "Simple product discovery": "Búsqueda sencilla de productos",
    "Fast booking": "Reserva rápida",
    "Clear coaching options": "Opciones de clases claras",
    "Equipment browsing": "Exploración de equipamiento",
    "Essential supplies": "Suministros esenciales",
    "Clear categories": "Categorías claras"
  },
  "objectives": {
    "Fastest Checkout": "Cobro más rápido",
    "Increase Retail Sales": "Aumentar ventas de tienda",
    "Premium Merchandising": "Presentación de gama alta",
    "Self-Service Friendly": "Facilitar el autoservicio",
    "Fast Staff Training": "Formación rápida del personal"
  },
  "metrics": {
    "Pages affected": "Páginas afectadas",
    "New pages": "Páginas nuevas",
    "Updated pages": "Páginas actualizadas",
    "New folders": "Carpetas nuevas",
    "Unique products": "Productos únicos",
    "Home shortcuts": "Accesos directos de inicio",
    "Actions": "Acciones",
    "Deletions": "Eliminaciones"
  },
  "fragments": {
    "message0": "Buscar {v0}",
    "message1": "Predeterminado {v0}",
    "message2": " • Menú predeterminado: {v0}",
    "message3": "Asignado a {v0} punto(s) de venta",
    "message4": "SKU {v0}",
    "message5": "Impuesto {v0}",
    "message6": "Este producto está vinculado uno a uno con {v0}.",
    "message7": "Quitar mesa {v0}",
    "message8": "Añadido: {v0}",
    "message9": "{v0}Mesa {v1}",
    "message10": "{v0} asientos",
    "message11": "Esta plantilla tiene {v0} asignación(es) de punto de venta: {v2}.",
    "message12": "¿Eliminar {v0}? {v1} botón(es) de carpeta ({v3}) abren esta página diseñada. Si continúas, esas carpetas utilizarán la distribución automática de sus nodos secundarios.",
    "message13": "Abrir panel {v0}",
    "message14": "{v0}, próximamente, no disponible",
    "message15": "Mostrar resumen de {v0}",
    "message16": "{v0} sin vincular",
    "message17": "Seleccionar mesa {v0}",
    "message18": "Mesa {v0}"
  },
  "nodeTypes": {
    "product": "Producto",
    "folder": "Carpeta",
    "action": "Acción",
    "dynamic": "Contenido dinámico"
  }
};
